import { useState } from 'react';
import { Layout, PostCard, PricingPage, CorporateImplementationGuide, GuideImplementationCarousel} from '.'

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
{
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityCalorie.png',
    altText: 'Track steps, distance, calories, and more with our advanced in-app activity tracker and calorie-counter.',
    caption: 'Activity & Calorie Tracker',
    imagealtText:'corporate wellness platform',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/heartrateM.png',
    altText: 'Measure your heart rate and be aware of your health with our highly accurate heart rate monitor. ',
    caption: 'Heart Rate Monitor',
    imagealtText:'corporate wellness platform',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/FeaturesWearables.png',
    altText: 'Connect from a wide list of supported wearable devices to seamlessly track and sync your workouts.',
    caption: 'Wearable Devices',
    imagealtText:'corporate wellness platform',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Challengesandcontests.png',
    altText: 'Create and host various exciting wellness challenges with automated incentivization on successful completion of in-house health campaigns.',
    caption: 'Contest & Challenges',
    imagealtText:'corporate wellness platform',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Healthassessment.png',
    altText: 'Easily assess your health and get effective recommendations to become fitter and healthier.',
    caption: 'Health Risk Assessment',
    imagealtText:'corporate wellness platform',
    link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/MoodoMeter.png',
    altText: 'Gauge how your employees are feeling and take proper steps to cheer them up for ensuring high productivity.',
    caption: 'Mood-O-Meter',
    imagealtText:'office health competitions',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/FitPoints.png',
    altText: 'Celebrate winning moments with redeemable points which can be used to purchase products across various categories and e-commerce sites.',
    caption: 'Redeemable Fitness Points',
    imagealtText:'virtual marathons',
     link:'/features/'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/realtimeleaderboard.png',
    altText: 'Ignite the inner sportsmanship within your employees and encourage healthy competition with our built-in real-time leaderboard.',
    caption: 'Realtime Leaderboard',
    imagealtText:'virtual marathons',
     link:'/features/'
  }
];

const LeadgenCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
      <div className="row column-change  d-flex align_items_center ">
      <div className="col-lg-5 col-md-7 col-xs-12 col-sm-12">
      <div className="carouselhr"><CarouselCaption captionText={item.altText} captionHeader={item.caption}/>
      <div></div>
      </div></div>
      <div className="col-lg-7 col-md-5 col-xs-12 col-sm-12 pclr text-center">
      <img src={item.src} alt={item.imagealtText} className = "max-w"/>
      </div><div className = "clearfix"></div>  </div>   

      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  );
}

export default LeadgenCarousel;



